import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const menuItems = [
    {
      path: '/dashboard',
      icon: '📊',
      label: 'Dashboard',
      description: 'Overview & Analytics',
      roles: ['superadmin', 'admin', 'user']
    },
    {
      path: '/superadmin',
      icon: '👑',
      label: 'Super Admin',
      description: 'Manage Admins',
      roles: ['superadmin']
    },
    {
      path: '/upload',
      icon: '📤',
      label: 'Upload Video',
      description: 'Add new content',
      roles: ['admin', 'user']
    },
    {
      path: '/videos',
      icon: '🎬',
      label: 'Videos',
      description: 'Manage videos',
      roles: ['admin', 'user']
    },
    {
      path: '/categories',
      icon: '📁',
      label: 'Categories',
      description: 'Manage categories',
      roles: ['admin', 'user']
    }
  ].filter(item => !item.roles || item.roles.includes(user.role));

  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2 className="sidebar-title">YouTube CRM</h2>
        <p className="sidebar-subtitle">Content Management</p>
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.path}
            className={`sidebar-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="sidebar-icon">{item.icon}</span>
            <div className="sidebar-content">
              <span className="sidebar-label">{item.label}</span>
              <span className="sidebar-description">{item.description}</span>
            </div>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
